import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Flex, FormControl } from '@tq/ui-components';

import { SearchText } from 'components';
import { mangeOrganisationsSearchState } from 'store';
import { useGetManageOrganisationRecords } from '../hooks';

export const OrganisationFilters: React.FC = () => {
  const { t } = useTranslation('manage_consultees');
  const { searchMatchCount, totalCount } = useGetManageOrganisationRecords();

  return (
    <Flex
      id='table-filter'
      width={{ base: '100%', lg: '33%' }}
      mb={{ base: '1.25rem', lg: 0 }}
      p={{ base: '1.25rem', lg: 0 }}
      flexDirection={{ base: 'column', lg: 'row' }}
      bg={{ base: COLOURS.gray[200], lg: COLOURS.white }}
    >
      <FormControl flex='1 1 100%'>
        <SearchText
          searchState={mangeOrganisationsSearchState}
          placeholderText={t('search_placeholder', 'Search by name or email')}
          recordCount={searchMatchCount}
          totalCount={totalCount}
        />
      </FormControl>
    </Flex>
  );
};
